import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAttractionDetails, IAttractionInitialState } from "./attractionModel";
import { getAttractionByURL } from "./services/attraction.services";

const initialState: IAttractionInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  AttractionID: null,
  AttractionList: [],
  AttractionDetail: {
    ID: null,
    Title: "",
    AttractionURL: "",
    PropertyID: null,
    AttractionCategory: "",
    TagLine: "",
    Distance: "",
    TravelTime: "",
    BestTime: "",
    Duration: "",
    Description: "",
    Dos: "",
    Donts: "",
    MainImage: "",
    BannerImage: "",
    MetaTitle: "",
    MetaDescription: "",
    MetaKeywords: "",
    IsActive: 1,

    BestTimes: [],
    HowToReach: [],
    ThingsToDo: [],
    WhyVisit: [],
    Nearby: [],
    Images: [],
  },
};

const attractionSlice = createSlice({
  name: "attraction",
  initialState,
  reducers: {
    clearAttractionDetails: (state) => {
      state.AttractionDetail = initialState.AttractionDetail;
    },
    setAttractionID: (state, action) => {
      state.AttractionID = action.payload;
    },
    clearAttractionID: (state) => {
      state.AttractionID = initialState.AttractionID;
    },
    setAttractionDetail: (state, action: PayloadAction<IAttractionDetails>) => {
      state.AttractionDetail = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAttractionByURL.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAttractionByURL.fulfilled,
      (state, action: PayloadAction<IAttractionDetails>) => {
        state.loading = false;
        state.AttractionDetail = action.payload;
      },
    );
    builder.addCase(getAttractionByURL.rejected, (state, action) => {
      state.loading = false;
      state.AttractionDetail = initialState.AttractionDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearAttractionDetails,
  clearAttractionID,
  setAttractionID,
  setAttractionDetail,
} = attractionSlice.actions;
export default attractionSlice.reducer;
